<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        flat
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
      >
        <v-container>
          <v-row dense>
            <v-col cols="12">
              <div class="client-profile-bar">
                <div class="user-profile client-profile">
                  <div class="profile-image">
                    <v-badge
                      avatar
                      bordered
                      overlap
                      :class="
                        $vuetify.theme.dark
                          ? 'blue-darken-2 '
                          : 'white-lighten-2'
                      "
                      icon="mdi-star-outline"
                    >
                      <v-avatar size="59">
                        <v-img src="@/assets/avatar.png"></v-img>
                      </v-avatar>
                    </v-badge>
                  </div>
                  <div class="profile-text">
                    <span
                      >{{
                        clienttree?.user_info?.fname +
                        " " +
                        clienttree?.user_info?.lname
                      }}
                      <strong>IB:{{ clienttree?.user_info?.id }}</strong></span
                    >
                    <span>Parent Partner (Me)</span>
                  </div>
                </div>
                <v-dialog
                  transition="scale-transition"
                  origin="center center"
                  max-width="554"
                  v-model="dialog"
                  content-class="deposit-withdraw-popup"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      tile
                      v-bind="attrs"
                      v-on="on"
                      elevation="0"
                      @click="handleUser(clienttree?.user_info?.id)"
                      class="text-capitalize btn-account mr-2 ml-n1"
                      color="teal-lighten-1"
                      >see details</v-btn
                    >
                  </template>
                  <v-card
                    class="rounded-0 px-0"
                    :class="
                      $vuetify.theme.dark ? 'blue-darken-2' : 'secondary2'
                    "
                  >
                    <v-card-title class="rounded-0 pb-5"
                      >Client ID: {{ clienttree?.user_info?.id }}</v-card-title
                    >
                    <v-card-actions class="text-center flex-column">
                      <p class="mb-1">
                        Name:
                        <span class="text--ash">
                          {{ partnerprofile?.user_name }}</span
                        >
                      </p>
                      <p class="mb-1">
                        Email:
                        <span class="text--ash">{{
                          partnerprofile?.email
                        }}</span>
                      </p>
                      <p class="mb-1">
                        IB Code:
                        <span class="text--ash">
                          {{ partnerprofile?.client_id }}</span
                        >
                      </p>
                    </v-card-actions>
                    <ul class="ma-0 pa-0 py-10 px-0">
                      <li class="d-flex justify-space-between px-sm-10 px-4">
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2">IB Code</span>
                          <span class="d-block text--white">{{
                            partnerprofile?.client_id
                          }}</span>
                        </div>
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2 text-right"
                            >Email Address</span
                          >
                          <span class="d-block text--white text-right">{{
                            partnerprofile?.email
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-space-between px-sm-10 px-4">
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2">Deposit</span>
                          <span class="d-block text--white">{{
                            partnerprofile?.total_deposit
                          }}</span>
                        </div>
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2 text-right"
                            >Net Deposit</span
                          >
                          <span class="d-block text--white text-right">{{
                            partnerprofile?.total_net_deposit
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-space-between px-sm-10 px-4">
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2">Withdraw</span>
                          <span class="d-block text--white">{{
                            partnerprofile?.total_withdrawal
                          }}</span>
                        </div>
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2 text-right"
                            >Total Earning</span
                          >
                          <span class="d-block text--white text-right">{{
                            partnerprofile?.ib_balance
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-space-between px-sm-10 px-4">
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2">Commission</span>
                          <span class="d-block text--white">{{
                            partnerprofile?.ib_commission
                          }}</span>
                        </div>
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2 text-right"
                            >Number Of Accounts</span
                          >
                          <span class="d-block text--white text-right">{{
                            partnerprofile?.totalTradingAccounts
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-space-between px-sm-10 px-4">
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2">Profit</span>
                          <span class="d-block text--white"
                            >{{
                              partnerprofile?.totalProfit !== undefined &&
                              !isNaN(partnerprofile.totalProfit)
                                ? partnerprofile.totalProfit
                                : "N/A"
                            }}
                          </span>
                        </div>
                        <div class="infos py-3">
                          <span class="d-block text--ash mb-2 text-right"
                            >IB Account</span
                          >
                          <span class="d-block text--white text-right">{{
                            partnerprofile?.ibAccount || "N/A"
                          }}</span>
                        </div>
                      </li>
                    </ul>
                    <v-btn
                      tile
                      outlined
                      @click="dialog = false"
                      elevation="0"
                      class="text-capitalize btn-account mx-auto d-flex px-16"
                      >Close</v-btn
                    >
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  CLIENTTREE__ACTIONS,
  PARTNERPROFILE__ACTIONS,
} from "@/store/action-types";

export default {
  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    ...mapState("clienttree", ["clienttree"]),
    ...mapState("partnerprofile", ["partnerprofile"]),
  },

  methods: {
    ...mapActions("clienttree", [CLIENTTREE__ACTIONS.CLIENTTREE]),
    ...mapActions("partnerprofile", [PARTNERPROFILE__ACTIONS.PARTNERPROFILE]),
    handleUser(id) {
      const parameter = {
        id: id,
      };
      this[PARTNERPROFILE__ACTIONS.PARTNERPROFILE](parameter);
    },
  },

  mounted() {
    this[CLIENTTREE__ACTIONS.CLIENTTREE]();
  },
};
</script>
